export function sumArray(numbers: []) {
  if (numbers) {
    if (numbers.length === 0 || !numbers) {
      return 0;
    } else {
      return numbers.reduce((total, num) => total + num, 0);
    }
  }
}
